<template>
  <div class="recommend">
    <SideBar></SideBar>
    <div class="banner"></div>
    <div class="doc-body">
      <Breadcrumb class="bread"
                  separator=">">
        <!-- <BreadcrumbItem to="/">
          <img class="bread-icon"
               src="../assets/images/icon-location.png" />首页
        </BreadcrumbItem> -->
        <!--<BreadcrumbItem class="bread-last">权威专家</BreadcrumbItem>-->
      </Breadcrumb>
      <!-- <Bread class="bread"></Bread> -->
      <Search class="search"
              @searchResult="searchResult" />
      <div class="doctor-list">
        <template v-for="(d,index) in list">
          <router-link :key="index"
                       :to="{name: 'DoctorInfo',params:{ id: d.id} }"
                       target="_blank"
                       class="doctor text-center">
            <span class="doctor-label">推荐专家</span>
            <div class="doctor-pic-box">
              <img class="doctor-avatar"
                   :src="baseURL + d.avatar"
                   alt="" />
            </div>

            <h5 class="doctor-name"
                v-html="setDoctorName(d.name)">
              <!-- {{d.name.replace(/\n/g, "<br/>")}} -->
              <!-- {{d.name.split("（")[0]}}<br/> {{d.name.split("（")[1]?'（'+d.name.split("（")[1]:''}} -->
            </h5>
            <div class="doctor-titles">
              <p class="doctor-title"
                 v-for="(dd,i) in d.doctor_disease"
                 :key="dd.id">{{dd.disease_name}}</p>
            </div>
            <p class="doctor-skill show-overflow"
               v-html="setDoctorName(d.easy_brief)">
              <!-- {{d.easy_brief}} -->
            </p>
          </router-link>
        </template>
      </div>
      <div class="page-box text-center">
        <Page class-name="pages"
              :total="total"
              prev-text="上一页"
              next-text="下一页"
              show-elevator
              show-total
              :page-size="15"
              @on-change="changePage" />
      </div>
    </div>
  </div>
</template>
<script>
import doctor from '@/assets/images/doctor/doctor.png'
import Search from '@/components/SearchOfDoctor.vue'
import SideBar from "@/components/SideBar"
import * as apis from '@/api/doctor'
import { baseURL } from '@/api/axios'
import { cloneDeep } from 'clone-deep'
export default {
  data () {
    return {
      total: 0,
      doctor: doctor,
      baseURL: baseURL,
      list: [],
      doctorTypes: {

        state_id: '',   //国家
        disease_id: [],    //疾病
      },
      pageType: 0
    }
  },
  components: {
    // Bread,
    Search,
    SideBar
  },
  mounted () {
    this.getList(1);
  },
  methods: {
    async getList (index) {
      try {
        let data = {
          page: index,
          // ...this.hospital
          state_id: this.doctorTypes.state_id,       //国家
          disease_id: this.doctorTypes.disease_id,     //其他三种类型，以逗号拼接
          keyword: this.doctorTypes.keyword
        };
        let res = await apis.getAllDoctors(data);
        if (res.code == 200) {
          this.list = res.data.data;
          this.total = res.data.total;
          window.scrollTo(0, 0);
        }
      } catch (e) {
        console.log(e)
      }
    },
    changePage (index) {
      this.getList(index);
    },
    searchResult (val) {
      this.doctorTypes.state_id = val.state_id;
      let str = val.disease_id.reduce((prev, curr) => {
        if (curr != '') {
          return prev + curr + ','
        } else {
          return prev + curr
        }
      }, '')
      str = str.substr(0, str.length - 1);
      this.doctorTypes.disease_id = str;
      this.doctorTypes.keyword = val.keyword
      this.getList(1);
    },
    setDoctorName (name) {
      if (name) {
        return name.replace(/\n/g, "<br/>");
      } else {
        return ''
      }
      // conosle.log(abc)
      // let nameArr,
      //   str
      // if (name.includes('（')) {
      //   nameArr = name.split("（")
      //   let fullName = ''
      //   if (nameArr.length > 1 && nameArr[1]) {
      //     fullName = '（' + nameArr[1]
      //   }
      //   str = nameArr[0] + '<br>' + fullName
      // } else if (name.includes('(')) {
      //   nameArr = name.split("(")
      //   let fullName = ''
      //   if (nameArr.length > 1 && nameArr[1]) {
      //     fullName = '(' + nameArr[1]
      //   }
      //   nameArr = name.split("(")
      //   str = nameArr[0] + '<br>' + fullName
      // }
      // return str
    }
  }
}
</script>
<style lang="less" scoped>
.banner {
  height: 250px;
  background: url('../assets/images/doctor/banner.png') no-repeat center;
}

.bread {
  margin: 40px 0;
}
.search {
  margin-bottom: 30px;
}

.page-box {
  margin-bottom: 70px;
}
</style>
<style lang="less">
.doc-body {
  width: 970px;
  margin: 0 auto;
}
.doctor-list {
  width: 980px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 20px;
}
.doctor {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 310px;
  height: 430px;
  background: #fff;
  padding: 20px 10px 40px;
  margin-bottom: 25px;
  margin-right: 10px;
  .doctor-label {
    position: absolute;
    left: 6px;
    top: 15px;
    display: inline-block;
    width: 87px;
    height: 37px;
    background: url('../assets/images/doctor/icon.png') no-repeat center;
    color: #fff;
    font-size: 14px;
    line-height: 37px;
  }
  .doctor-avatar {
    // width: 120px;
    // height: 120px;
    // border-radius: 60px;
    // margin-bottom: 36px;
  }
  .doctor-name {
    font-size: 22px;
    color: #333130;
    line-height: 40px;
    margin-bottom: 28px;
  }
  .doctor-titles {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    height: 32px;
    overflow: hidden;
    margin-bottom: 15px;
  }
  .doctor-title {
    font-size: 12px;
    color: #333130;
    line-height: 28px;
    margin: 0 6px;
  }
  .doctor-skill {
    height: 56px;
    font-size: 14px;
    color: #333130;
    line-height: 18px;
  }
  .doctor-pointer {
    margin: 140px 0 70px;
  }
}
.show-overflow {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
</style>
